module.exports = __webpack_public_path__ + "assets/img/marriage-info.553ed36f.png";